import {CheckDone01Icon} from '@components/ui/icon'
import {EmptyState} from '@components/commons/empty-search'
import {useTranslation} from '@/translations/i18n.tsx'
import {useParsedSearchParams} from '@hooks/useParsedSearchParams.ts'
import {AssignmentsURLParams} from '@features/home/types.ts'

export const HomeTableEmptyState = () => {
    const {searchParams} = useParsedSearchParams(AssignmentsURLParams)

    const {t} = useTranslation()
    return (
        <EmptyState
            icon={<CheckDone01Icon size={32} />}
            title={t('home:table:empty_title', {tab: t(`home:${searchParams.filter_value}`)})}
            subtitle={t('home:table:empty_state:subtitle')}
        />
    )
}
